import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "w-full flex items-center justify-between p-3" };
const _hoisted_2 = { class: "flex-1 w-full py-2 px-3 scroll-smooth overflow-y-auto" };
const _hoisted_3 = {
    class: "grid gap-4 h-auto w-full grid-cols-1",
    id: "market-products"
};
const _hoisted_4 = {
    key: 0,
    class: "flex flex-row gap-4 w-full h-auto items-center justify-center p-3"
};
import { ref, watch } from "vue";
import { useHomeStore } from "./homeStore";
import { CheckCircle2, Copy, X } from "lucide-vue-next";
import HomeShareDialogItem from "./home-share-dialog-item.vue";
// MARK: Store usage
const shareButtonClasses = "flex items-center justify-center size-10 bg-white rounded-[4px] cursor-pointer text-badge z-1 text-sm drop-shadow-lg";
// MARK: Function
export default /*@__PURE__*/ _defineComponent({
    __name: 'home-share-dialog',
    setup(__props) {
        const homeStore = useHomeStore();
        // MARK: Ref value
        const showContent = ref(false);
        const showCopyTick = ref(false);
        // MARK: Value
        const copyShare = async () => {
            await navigator.clipboard.writeText(homeStore.selectedItemsURLString);
            showCopyTick.value = true;
            setTimeout(() => {
                showCopyTick.value = false;
            }, 2000);
        };
        const whatsappShare = () => {
            window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(homeStore.selectedItemsURLString)}`);
        };
        const facebookShare = () => {
            const url = `https://${window.location.host}/listing/${homeStore.selectedItems[0].id}`;
            window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`);
        };
        // const twitterXShare = (): void => {
        //   window.open(
        //     `https://twitter.com/intent/tweet?text=${encodeURIComponent(
        //       homeStore.selectedItemsURLString
        //     )}`
        //   );
        // };
        // Watch for when the filter menu becomes visible
        watch(() => homeStore.showShareDialog, (newValue) => {
            if (newValue) {
                setTimeout(() => {
                    document.body.style.overflow = "hidden";
                    showContent.value = true;
                }, 100);
            }
        });
        const closeDialog = () => {
            showContent.value = false;
            setTimeout(() => {
                document.body.style.overflow = "";
                homeStore.showShareDialog = false;
            }, 100);
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _cache[10] || (_cache[10] = _createElementVNode("link", {
                    rel: "stylesheet",
                    href: "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.0/css/all.min.css"
                }, null, -1)),
                (_unref(homeStore).showShareDialog)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "fixed left-0 top-0 z-50 h-[var(--safe-height)] w-full bg-black/30 backdrop-blur-sm flex items-center justify-center",
                        onClick: _cache[5] || (_cache[5] = ($event) => (closeDialog()))
                    }, [
                        _createVNode(_Transition, {
                            "enter-active-class": "transition ease-out duration-100 transform",
                            "enter-from-class": "opacity-0 scale-95",
                            "enter-to-class": "opacity-100 scale-100",
                            "leave-active-class": "transition ease-in duration-75 transform",
                            "leave-from-class": "opacity-100 scale-100",
                            "leave-to-class": "opacity-0 scale-95"
                        }, {
                            default: _withCtx(() => [
                                (showContent.value)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: "w-11/12 h-5/6 bg-white rounded-[20px] border border-badge flex flex-col justify-start items-center max-w-[500px]",
                                        onClick: _cache[4] || (_cache[4] = _withModifiers(() => { }, ["stop"]))
                                    }, [
                                        _createElementVNode("div", _hoisted_1, [
                                            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "size-8" }, null, -1)),
                                            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "text-3xl font-medium text-badge" }, "Share Listing(s)", -1)),
                                            _createVNode(_unref(X), {
                                                class: "size-8 text-badge cursor-pointer",
                                                onClick: _cache[0] || (_cache[0] = ($event) => (closeDialog()))
                                            })
                                        ]),
                                        _createElementVNode("div", _hoisted_2, [
                                            _createElementVNode("div", _hoisted_3, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(homeStore).selectedItems, (item) => {
                                                    return (_openBlock(), _createBlock(HomeShareDialogItem, {
                                                        key: item.id,
                                                        data: item
                                                    }, null, 8, ["data"]));
                                                }), 128))
                                            ])
                                        ]),
                                        (_unref(homeStore).selectedItems.length > 0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                                _createElementVNode("div", {
                                                    class: _normalizeClass(shareButtonClasses),
                                                    onClick: _cache[1] || (_cache[1] = ($event) => (copyShare()))
                                                }, [
                                                    (showCopyTick.value)
                                                        ? (_openBlock(), _createBlock(_unref(CheckCircle2), { key: 0 }))
                                                        : (_openBlock(), _createBlock(_unref(Copy), { key: 1 }))
                                                ]),
                                                _createElementVNode("div", {
                                                    class: _normalizeClass(shareButtonClasses),
                                                    onClick: _cache[2] || (_cache[2] = ($event) => (whatsappShare()))
                                                }, [...(_cache[8] || (_cache[8] = [
                                                        _createElementVNode("i", {
                                                            class: "fa-brands fa-whatsapp",
                                                            style: { "font-size": "24px" }
                                                        }, null, -1)
                                                    ]))]),
                                                (_unref(homeStore).selectedItems.length === 1)
                                                    ? (_openBlock(), _createElementBlock("div", {
                                                        key: 0,
                                                        class: _normalizeClass(shareButtonClasses),
                                                        onClick: _cache[3] || (_cache[3] = ($event) => (facebookShare()))
                                                    }, [...(_cache[9] || (_cache[9] = [
                                                            _createElementVNode("i", {
                                                                class: "fa-brands fa-facebook-f",
                                                                style: { "font-size": "24px" }
                                                            }, null, -1)
                                                        ]))]))
                                                    : _createCommentVNode("", true)
                                            ]))
                                            : _createCommentVNode("", true)
                                    ]))
                                    : _createCommentVNode("", true)
                            ]),
                            _: 1
                        })
                    ]))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
